import {BasePage} from "app/types/PageTypes";
import {Redirect, Switch} from "react-router-dom";

const SettingsPage = (props: BasePage) => {

  return (
      <Switch>
        {props.children}
        <Redirect to='/settings/reset-password'/>
      </Switch>
  );
};

export default SettingsPage;